import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Box, Button, Select, Container, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import { t } from "i18next";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { GetNameChoose } from "../../funcUtils";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import NumbersRoundedIcon from "@mui/icons-material/NumbersRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
        ref={ref}
        value={value}
        onClick={onClick}
        placeholder="Chọn ngày"
        style={{
            height: "40px",
            padding: "0 10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            outline: "none",
            fontSize: "14px",
            color: "#333",
            backgroundColor: "#fff",
            width: "120px",
            textAlign: "center",
            cursor: "pointer"
        }}
        readOnly
    />
));

function HistoryBetAll() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);
    const [searched, setSearched] = useState("");
    const [isShow, setShow] = useState(false);
    const [ls, setLs] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d;
    });
    const [endDate, setEndDate] = useState(() => new Date());
    const [selectedSanh, setSelectedSanh] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [total, setTotal] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [totalBet, setTotalBet] = useState(0);
    const [totalWin, setTotalWin] = useState(0);
    const [totalLoss, setTotalLoss] = useState(0);
    const [isGuideOpen, setIsGuideOpen] = useState(false);
    const [loaiGame, setLoaiGame] = useState("Minigame");
    const [idPhien, setIdPhien] = useState("");

    // States cho phân trang và tìm kiếm
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 12;
    const typingTimeoutRef = useRef(null);

    const [activePreset, setActivePreset] = useState("all");

    const setDatePreset = (preset) => {
        const today = new Date();
        setPage(1);
        setActivePreset(preset);
        switch (preset) {
            case "today": {
                const start = new Date(today);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "yesterday": {
                const start = new Date(today);
                start.setDate(today.getDate() - 1);
                setStartDate(start);
                setEndDate(start);
                break;
            }
            case "thisWeek": {
                const start = new Date(today);
                const day = today.getDay();
                const diff = today.getDate() - day + (day === 0 ? -6 : 1);
                start.setDate(diff);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "thisMonth": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                setStartDate(start);
                setEndDate(today);
                break;
            }
            case "lastMonth": {
                const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                const end = new Date(today.getFullYear(), today.getMonth(), 0);
                setStartDate(start);
                setEndDate(end);
                break;
            }
            case "all":
            default: {
                setStartDate(null);
                setEndDate(null);
                break;
            }
        }
    };

    const parseTraditionalResult = (resultStr, idBet) => {
        if (!resultStr) return null;
        const parts = resultStr.trim().split(/\s+/);
        if (parts.length === 0 || parts[0] === "") return null;
        return {
            id_bet: idBet,
            dacbiet: parts[0] || "",
            nhat: parts[1] || "",
            hai: parts.slice(2, 4).join(" "),
            ba: parts.slice(4, 10).join(" "),
            tu: parts.slice(10, 14).join(" "),
            nam: parts.slice(14, 20).join(" "),
            sau: parts.slice(20, 23).join(" "),
            bay: parts.slice(23, 27).join(" ")
        };
    };

    const openPopup = (item) => {
        let parsed = null;
        if (item && item.id_bet && typeof item.id_bet === "object") {
            const resultStr = item.id_bet.result || item.result || "";
            const idBet = item.id_bet.id_bet || item.id_bet._id || item.id_bet;
            parsed = parseTraditionalResult(resultStr, idBet);
        } else if (item && typeof item.id_bet === "string") {
            parsed = parseTraditionalResult(item.result, item.id_bet);
        } else {
            parsed = item;
        }

        if (!parsed) {
            const idBet = (item && typeof item.id_bet === "object")
                ? (item.id_bet.id_bet || item.id_bet._id || item.id_bet)
                : (item?.id_bet || "");
            parsed = {
                id_bet: idBet,
                dacbiet: "Đang cập nhật",
                nhat: "Đang cập nhật",
                hai: "",
                ba: "",
                tu: "",
                nam: "",
                sau: "",
                bay: ""
            };
        }
        setTotal(parsed);
        setIsOpen(true);
    };
    const closePopup = () => {
        setIsOpen(false);
    };

    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }

    // 🔥 HÀM DỊCH MÃ CƯỢC XÓC ĐĨA (FIX LUÔN LỖI CHỮ 'CHỌ' CỦA BACKEND) 🔥
    const getXocDiaBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = {
            "6": "Lẻ", "5": "Chẵn", "4": "3 Trắng, 1 Đỏ", "3": "3 Đỏ, 1 Trắng", "2": "4 Trắng", "1": "4 Đỏ",
            "le": "Lẻ", "lẻ": "Lẻ", "chan": "Chẵn", "chẵn": "Chẵn", "chọ": "Chẵn"
        };
        return String(stateStr).trim().split(/\s+/).map(s => map[s.toLowerCase()] || map[s] || s).join(", ");
    };

    // 🔥 HÀM DỊCH MÃ CƯỢC TÀI XỈU (FIX LUÔN LỖI CHỮ 'CHỌ' CỦA BACKEND) 🔥
    const getTaiXiuBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = {
            "1": "Tài", "2": "Xỉu", "3": "Chẵn", "4": "Lẻ",
            "tai": "Tài", "tài": "Tài", "xiu": "Xỉu", "xỉu": "Xỉu",
            "chan": "Chẵn", "chẵn": "Chẵn", "chọ": "Chẵn", "le": "Lẻ", "lẻ": "Lẻ"
        };
        return String(stateStr).trim().split(/\s+/).map(s => map[s.toLowerCase()] || map[s] || s).join(", ");
    };

    // Định dạng tiền / điểm cược chuẩn (không chia 1000, hiển thị tối đa 2 chữ số thập phân)
    const formatMoney = (val) => {
        if (val === null || val === undefined || isNaN(val)) return "0";
        return Number(val).toLocaleString("vi-VN", { maximumFractionDigits: 2 });
    };

    // Timezone-safe local date formatter (YYYY-MM-DD)
    const formatLocalDate = (date) => {
        if (!date) return "";
        const offset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - (offset * 60 * 1000));
        return localDate.toISOString().split('T')[0];
    };

    // Hàm gọi API fetching dữ liệu
    const fetchHistory = () => {
        setLoading(true);
        const startStr = formatLocalDate(startDate);
        const endStr = formatLocalDate(endDate);
        axios
            .get(`${process.env.REACT_APP_API_URL}/history/all?startDate=${startStr}&endDate=${endStr}&page=${page}&limit=${limit}&search=${searched}&sanh=${selectedSanh}&status=${selectedStatus}&loaiGame=${loaiGame}`)
            .then((res) => {
                setData(res.data.data);
                if (res.data.totalPages) setTotalPages(res.data.totalPages);
                setTotalBet(res.data.totalBet || 0);
                setTotalWin(res.data.totalWin || 0);
                setTotalLoss(
                    res.data.totalLoss !== undefined
                        ? res.data.totalLoss
                        : (res.data.data ? res.data.data.reduce((acc, curr) => acc + (Number(curr.money || 0) > Number(curr.moneythang || 0) ? Number(curr.money || 0) - Number(curr.moneythang || 0) : 0), 0) : 0)
                );
                setLoading(false);
            })
            .catch((err) => {
                setData(null);
                setLoading(false);
            });
    };

    // Tự động fetch khi page, date hoặc từ khóa search thay đổi
    useEffect(() => {
        fetchHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, startDate, endDate, searched, selectedSanh, selectedStatus, loaiGame]);

    // Xử lý tìm kiếm có Debounce
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1); // Trở về trang 1 khi tìm kiếm
        }, 500);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    const [st, setSt] = useState(0);
    const handleChangeStatus = (e) => {
        if (ls?.status_bet === "Lose" || ls?.status_bet === "Pending") {
            if (e.target.value === "Win") {
                setSt(1);
            }
        } else {
            if (e.target.value === "Lose" || e.target.value === "Pending") {
                setSt(2);
            }
        }
        setLs((prevLs) => ({
            ...prevLs,
            status_bet: e.target.value
        }));
    };

    const handleSubmitLs = (e) => {
        e.preventDefault();
        const formData = {
            id: ls?._id,
            userId: ls?.user?._id,
            status_bet: e.target.status_bet.value,
            state: e.target.state.value,
            money: e.target.money.value,
            moneyuser: st == 1 ? e.target.moneythang.value : st == 2 ? Number(ls?.moneythang) * -1 : 0,
            moneythang: e.target.moneythang.value
        };
        axios
            .patch(`${process.env.REACT_APP_API_URL}/history`, formData)
            .then((res) => {
                setShow(false);
                swal(t('success'), "", "success").then((value) => {
                    fetchHistory();
                });
            })
            .catch((err) => {
                setShow(false);
                swal(t('error'), "", "error");
            });
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            py: 1
                        }}>
                        {isLoading ? (
                            <div className="loading" style={{ maxWidth: "100%" }}>
                                <div className="loader"></div>
                            </div>
                        ) : null}
                        <Container maxWidth={false}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                                <div className="container_set" style={{ margin: 0 }}>Lịch sử đặt cược</div>
                                <button className="ax-guide-button" onClick={() => setIsGuideOpen(true)}>
                                    Hướng dẫn <span>?</span>
                                </button>
                            </Box>

                            {/* Top Stats Cards - 22Bet / AX68WIN Style */}
                            <div className="ax-white-card-row">
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#1565c0", fontWeight: 700 }}>TỔNG CƯỢC (LỌC)</div>
                                        <div className="ax-card-number" style={{ color: "#1565c0", fontWeight: 800 }}>{formatMoney(totalBet)}</div>
                                    </div>
                                    <div className="ax-card-icon blue"><MonetizationOnRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#2e7d32", fontWeight: 700 }}>TỔNG THẮNG (LỌC)</div>
                                        <div className="ax-card-number" style={{ color: "#2e7d32", fontWeight: 800 }}>{formatMoney(totalWin)}</div>
                                    </div>
                                    <div className="ax-card-icon green"><EmojiEventsRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: "#c62828", fontWeight: 700 }}>TỔNG THUA (LỌC)</div>
                                        <div className="ax-card-number" style={{ color: "#c62828", fontWeight: 800 }}>{formatMoney(totalLoss)}</div>
                                    </div>
                                    <div className="ax-card-icon red"><TrendingDownRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title" style={{ color: totalBet - totalWin >= 0 ? "#2e7d32" : "#c62828", fontWeight: 700 }}>TỔNG LỢI NHUẬN (LỌC)</div>
                                        <div className="ax-card-number" style={{ color: totalBet - totalWin >= 0 ? "#2e7d32" : "#c62828", fontWeight: 800 }}>
                                            {formatMoney(totalBet - totalWin)}
                                        </div>
                                    </div>
                                    <div className="ax-card-icon red"><TrendingUpRoundedIcon /></div>
                                </div>
                            </div>

                            {/* Filter Container - AX68WIN Style */}
                            <div className="ax-filter-block">
                                <div className="ax-filter-grid">
                                    <div className="ax-filter-item" style={{ minWidth: "320px" }}>
                                        <label><CalendarMonthRoundedIcon /> Khoảng thời gian</label>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                            <div className="ax-date-range">
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setStartDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                                <span style={{ color: "#888" }}>→</span>
                                                <DatePicker
                                                    maxDate={new Date()}
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setEndDate(date);
                                                        setPage(1);
                                                    }}
                                                    customInput={<CustomDateInput />}
                                                />
                                            </div>
                                            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: "4px" }}>
                                                {[
                                                    { key: "all", label: "Tất cả ngày" },
                                                    { key: "today", label: "Hôm nay" },
                                                    { key: "yesterday", label: "Hôm qua" },
                                                    { key: "thisWeek", label: "Tuần này" },
                                                    { key: "thisMonth", label: "Tháng này" },
                                                    { key: "lastMonth", label: "Tháng trước" }
                                                ].map((btn) => (
                                                    <button
                                                        key={btn.key}
                                                        type="button"
                                                        onClick={() => setDatePreset(btn.key)}
                                                        style={{
                                                            padding: "5px 12px",
                                                            fontSize: "12px",
                                                            borderRadius: "6px",
                                                            border: activePreset === btn.key ? "1px solid #1890ff" : "1px solid #d9d9d9",
                                                            background: activePreset === btn.key ? "#1890ff" : "#ffffff",
                                                            color: activePreset === btn.key ? "#ffffff" : "#1890ff",
                                                            fontWeight: activePreset === btn.key ? 700 : 600,
                                                            cursor: "pointer",
                                                            boxShadow: activePreset === btn.key ? "0 2px 6px rgba(24,144,255,0.35)" : "none",
                                                            transition: "all 0.2s"
                                                        }}
                                                    >
                                                        {btn.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label><SportsEsportsRoundedIcon /> Loại game</label>
                                        <select
                                            value={loaiGame}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "Game API") {
                                                    navigate("/admin/historyapi");
                                                } else {
                                                    setLoaiGame(val);
                                                }
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        >
                                            <option value="Minigame">Minigame</option>
                                            <option value="Blockchain">Blockchain</option>
                                            <option value="Game API">Game API</option>
                                            <option value="">Toàn bộ</option>
                                        </select>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label><BusinessRoundedIcon /> Sảnh</label>
                                        <select
                                            value={selectedSanh}
                                            onChange={(e) => {
                                                setSelectedSanh(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        >
                                            <option value="">Toàn bộ</option>
                                            <option value="XSMB">XSMB</option>
                                            <option value="XS75s">XS 75s</option>
                                            <option value="XS120s">XS 120s</option>
                                            <option value="XD45s">XD 45s</option>
                                            <option value="XD60s">XD 60s</option>
                                            <option value="TX45s">TX 45s</option>
                                            <option value="TX60s">TX 60s</option>
                                            <option value="TXMD5">TX MD5</option>
                                            <option value="TXLIVE">Tài Xỉu Live</option>
                                            <option value="XDLIVE">Xóc Đĩa Live</option>
                                            <option value="Baccarat60s">Baccarat Blockchain</option>
                                            <option value="XocDiaBlockchain60s">Xóc Đĩa Blockchain</option>
                                            <option value="RongHo60s">Rồng Hổ Blockchain</option>
                                            <option value="BauCua60s">Bầu Cua Blockchain</option>
                                        </select>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label><CategoryRoundedIcon /> Thể loại</label>
                                        <select
                                            value={selectedStatus}
                                            onChange={(e) => {
                                                setSelectedStatus(e.target.value);
                                                setPage(1);
                                            }}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        >
                                            <option value="">Toàn bộ</option>
                                            <option value="Win">Thắng</option>
                                            <option value="Lose">Thua</option>
                                            <option value="Pending">Chờ duyệt</option>
                                        </select>
                                    </div>

                                    <div className="ax-filter-item">
                                        <label><PersonRoundedIcon /> Tên người chơi</label>
                                        <input
                                            type="text"
                                            placeholder="Tên người chơi"
                                            onChange={handleSearchChange}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        />
                                    </div>

                                    <div className="ax-filter-item">
                                        <label><NumbersRoundedIcon /> Phiên</label>
                                        <input
                                            type="text"
                                            placeholder="ID phiên"
                                            value={idPhien}
                                            onChange={(e) => setIdPhien(e.target.value)}
                                            style={{ height: "40px", padding: "0 12px", borderRadius: "8px", border: "1px solid #ddd", fontSize: "13px" }}
                                        />
                                    </div>

                                    <div className="ax-filter-item">
                                        <button className="ax-btn-search-red" onClick={() => { setPage(1); fetchHistory(); }}>
                                            <SearchRoundedIcon /> Tìm kiếm
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Filtered 4 Summary Cards - AX68WIN Style */}
                            <div className="ax-white-card-row">
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title">Tổng cược</div>
                                        <div className="ax-card-number">{formatMoney(totalBet)}</div>
                                    </div>
                                    <div className="ax-card-icon blue"><MonetizationOnRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title">Tổng thắng</div>
                                        <div className="ax-card-number">{formatMoney(totalWin)}</div>
                                    </div>
                                    <div className="ax-card-icon green"><EmojiEventsRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title">Tổng thua</div>
                                        <div className="ax-card-number">{formatMoney(totalLoss)}</div>
                                    </div>
                                    <div className="ax-card-icon red"><TrendingDownRoundedIcon /></div>
                                </div>
                                <div className="ax-white-card">
                                    <div>
                                        <div className="ax-card-title">Tổng thắng/thua</div>
                                        <div className="ax-card-number" style={{ color: totalWin - totalBet >= 0 ? "#2e7d32" : "#d32f2f" }}>
                                            {totalWin - totalBet > 0 ? "+" : ""}{formatMoney(totalWin - totalBet)}
                                        </div>
                                    </div>
                                    <div className="ax-card-icon green"><TrendingUpRoundedIcon /></div>
                                </div>
                            </div>

                            <div className="ax-table-wrapper">
                                <Table>
                                    <TableHead sx={{ backgroundColor: "#FF0000" }}>
                                        <TableRow>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '100px' }}>PHIÊN</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '120px' }}>TÊN TÀI KHOẢN</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '100px' }}>SỐ DƯ</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '120px' }}>LOẠI GAME</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '150px' }}>CƯỢC</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '150px', textAlign: 'center' }}>KẾT QUẢ</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '100px' }}>TIỀN CƯỢC</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '100px' }}>TIỀN THẮNG</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '100px' }}>TRẠNG THÁI</TableCell>
                                            <TableCell sx={{ padding: "12px 10px", color: "#FFFFFF !important", fontWeight: "700 !important", minWidth: '120px' }}>THỜI GIAN</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {data != null && data.length > 0 ? (
                                        <TableBody>
                                            {data.map((item) => {
                                                let gameType = "UNKNOWN";
                                                const sanhStr = String(item?.sanh || "").trim();
                                                const sanhLower = sanhStr.toLowerCase();
                                                const typeStr = String(item?.type || "").trim().toUpperCase();
                                                const gameName = String(item?.game || "").trim();

                                                if (typeStr.includes("BACCARAT")) {
                                                    gameType = "BACCARAT";
                                                } else if (typeStr.includes("RONGHO") || typeStr.includes("RỒNG HỔ")) {
                                                    gameType = "RONGHO";
                                                } else if (typeStr.includes("BAUCUA") || typeStr.includes("BẦU CUA")) {
                                                    gameType = "BAUCUA";
                                                } else if (typeStr.includes("XD")) {
                                                    gameType = "XOCDIA";
                                                } else if (typeStr.includes("TX")) {
                                                    gameType = "TAIXIU";
                                                } else if (typeStr.includes("CATDOG")) {
                                                    gameType = "CATDOG";
                                                } else if (typeStr.includes("XS") || gameName.toLowerCase().includes("xổ số") || sanhLower.includes("xs")) {
                                                    gameType = "XOSO";
                                                } else if (sanhLower.includes("xổ số")) {
                                                    gameType = "XOSO";
                                                } else if (sanhLower.includes("catdog") || sanhLower.includes("cat dog")) {
                                                    gameType = "CATDOG";
                                                } else if (sanhLower.includes("tài xỉu") || sanhLower.includes("tx")) {
                                                    gameType = "TAIXIU";
                                                } else if (sanhLower.includes("xóc đĩa") || sanhLower.includes("xd")) {
                                                    gameType = "XOCDIA";
                                                } else if (item?.id_bet?.result) {
                                                    const parts = String(item.id_bet.result).trim().split(/\s+/);
                                                    if (parts.length === 3) gameType = "TAIXIU";
                                                    else if (parts.length === 4) gameType = "XOCDIA";
                                                }

                                                let gameNameDisplay = sanhStr;
                                                if (gameName && gameName !== "null" && gameName !== "") {
                                                    gameNameDisplay = `${gameName} (Sảnh ${sanhStr})`;
                                                } else if (gameType === "TAIXIU") {
                                                    if (/^\d+$/.test(sanhStr)) {
                                                        gameNameDisplay = `Tài xỉu Sảnh ${sanhStr}`;
                                                    } else if (sanhLower.match(/^tài xỉu \d+$/)) {
                                                        gameNameDisplay = sanhStr.replace(/tài xỉu/i, "Tài xỉu Sảnh");
                                                    }
                                                } else if (gameType === "XOCDIA") {
                                                    if (/^\d+$/.test(sanhStr)) {
                                                        gameNameDisplay = `Xóc đĩa Sảnh ${sanhStr}`;
                                                    } else if (sanhLower.match(/^xóc đĩa \d+$/)) {
                                                        gameNameDisplay = sanhStr.replace(/xóc đĩa/i, "Xóc đĩa Sảnh");
                                                    }
                                                }

                                                let mockSanh = sanhStr;
                                                if (gameType === "TAIXIU") mockSanh = "Tài xỉu";
                                                if (gameType === "XOCDIA") mockSanh = "Xóc đĩa";

                                                let displayBet = "";
                                                if (gameType === "XOCDIA") {
                                                    displayBet = getXocDiaBetLabel(item?.state);
                                                } else if (gameType === "TAIXIU") {
                                                    displayBet = getTaiXiuBetLabel(item?.state);
                                                } else if (gameType === "CATDOG") {
                                                    displayBet = String(GetNameChoose(String(item?.id_bet?.result || "").slice(-1), null, "CatDog") || "").replace("Chọn ", "");
                                                } else if (["BACCARAT", "RONGHO", "BAUCUA"].includes(gameType)) {
                                                    const betLabels = {
                                                        player: "Con", banker: "Cái", tie: "Hòa",
                                                        player_pair: "Con đôi", banker_pair: "Cái đôi", super_6: "Super 6",
                                                        rong: "Rồng", ho: "Hổ", hoa: "Hòa",
                                                        bau: "Bầu", cua: "Cua", tom: "Tôm", ca: "Cá", ga: "Gà", nai: "Nai"
                                                    };
                                                    displayBet = String(item?.state || "").split(/[ ,]+/).filter(Boolean).map((value) => betLabels[value.toLowerCase()] || value).join(", ");
                                                } else {
                                                    displayBet = GetNameChoose(item?.state, item?.type, mockSanh);
                                                }

                                                // Trích xuất mã phiên chuẩn từ database (ví dụ: 1944033, 1944034)
                                                let rawPhien = "";
                                                if (item?.id_bet && typeof item.id_bet === "object" && item.id_bet.id_bet) {
                                                    rawPhien = item.id_bet.id_bet;
                                                } else if (item?.id_bet && typeof item.id_bet === "object" && item.id_bet.session) {
                                                    rawPhien = item.id_bet.session;
                                                } else if (item?.phien || item?.session || item?.phien_id) {
                                                    rawPhien = item?.phien || item?.session || item?.phien_id;
                                                } else if (typeof item?.id_bet === "string" && /^\d+$/.test(item.id_bet)) {
                                                    rawPhien = item.id_bet;
                                                } else if (item?.createdAt && (gameType === "XOSO" || String(item?.sanh || "").toLowerCase().includes("xs"))) {
                                                    const d = new Date(item.createdAt);
                                                    rawPhien = ("0" + d.getDate()).slice(-2) + "/" + ("0" + (d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear();
                                                }
                                                const phienCuoc = String(rawPhien || item?.id_bet?._id || item?._id || "-");

                                                return (
                                                    <TableRow key={item._id} hover>
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            {phienCuoc}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px", color: "#1976d2" }}>
                                                            {item?.user?.username}
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            {item?.before != null ? formatMoney(item.before) : "-"}
                                                        </TableCell>

                                                        {/* 🔥 CỘT GAME ĐÃ ĐƯỢC CHUẨN HOÁ 🔥 */}
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            {gameNameDisplay}
                                                        </TableCell>

                                                        {/* 🔥 CỘT BET ĐÃ ĐƯỢC FIX LỖI CHỮ "CHỌ" 🔥 */}
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px", color: '#4b5563' }}>
                                                            Chọn: {displayBet}
                                                        </TableCell>

                                                        <TableCell sx={{ textAlign: "center", display: 'flex', justifyContent: 'center' }}>
                                                            {item?.id_bet && (
                                                                <>
                                                                    {gameType === "XOCDIA" && (
                                                                        <div
                                                                            className="history_xd"
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                transform: "scale(0.9)"
                                                                            }}>
                                                                            {String(item?.id_bet?.result || "").trim().split(" ").filter(Boolean).map((x, i) => (
                                                                                <div key={i} className={`a${x}`}></div>
                                                                            ))}
                                                                        </div>
                                                                    )}

                                                                    {gameType === "TAIXIU" && (
                                                                        <div
                                                                            className="history_xucsac"
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                transform: "scale(2.2)"
                                                                            }}>
                                                                            {String(item?.id_bet?.result || "").trim().split(" ").filter(Boolean).map((x, i) => (
                                                                                <div key={i} className={`n${x}`}></div>
                                                                            ))}
                                                                        </div>
                                                                    )}

                                                                    {/* 🔥 FIX NÚT XEM KẾT QUẢ CHO XỔ SỐ: CHẮC CHẮN HIỂN THỊ 🔥 */}
                                                                    {gameType === "XOSO" && (
                                                                        <Button
                                                                            size="small"
                                                                            variant="contained"
                                                                            color="error"
                                                                            sx={{ borderRadius: "10px", fontWeight: "bold" }}
                                                                            onClick={() => openPopup(item)}>
                                                                            {t("view")}
                                                                        </Button>
                                                                    )}

                                                                    {gameType === "CATDOG" && (
                                                                        <>{GetNameChoose(String(item?.id_bet?.result || "").slice(-1), null, "CatDog").replace("Chọn ", "")}</>
                                                                    )}

                                                                    {["BACCARAT", "RONGHO", "BAUCUA"].includes(gameType) && (
                                                                        <span style={{ fontWeight: 500, color: "#374151" }}>
                                                                            {String(item?.id_bet?.result || "Đang cập nhật")}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            <span style={{ color: "#e05260", fontWeight: 500 }}>
                                                                {formatMoney(item?.money)}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            <span style={{ color: "#10b981", fontWeight: 500 }}>
                                                                {formatMoney(item?.moneythang)}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: "500", padding: "10px" }}>
                                                            {String(item?.status_bet || "Pending").toLowerCase() === "win" ? (
                                                                <span className="badge success">{t("win")}</span>
                                                            ) : String(item?.status_bet || "").toLowerCase() === "lose" ? (
                                                                <span className="badge error">{t("lose")}</span>
                                                            ) : String(item?.status_bet || "Pending").toLowerCase() === "pending" ? (
                                                                <span className="badge warning">{t("pending")}</span>
                                                            ) : (
                                                                <span className="badge cancel">{t("canceled")}</span>
                                                            )}
                                                        </TableCell>

                                                        <TableCell sx={{ fontWeight: "500", padding: "10px", fontSize: '13px' }}>
                                                            {formatDate(new Date(item?.createdAt))}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={12} align="center">{t("empty")}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )}
                                </Table>
                            </div>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    pt: 3
                                }}>
                                {data != null ? <Pagination color="primary" page={page} count={totalPages} size="small" onChange={handleChangePage} /> : null}
                            </Box>
                        </Container>
                    </Box>

                    {/* MODAL SỬA VÉ CƯỢC */}
                    {isShow === true ? (
                        <>
                            <div className="modal">
                                <div className="modaloverlay">
                                    <i className="ti-close closelogin" onClick={() => setShow(false)}></i>
                                </div>
                                <div className="modalbody">
                                    <form onSubmit={handleSubmitLs}>
                                        <div className="modalinner">
                                            <div className="modalheader"> {t("edit")} </div>

                                            <div className="modalform">
                                                <div className="modalformgroup d-flex" style={{ padding: "9px" }}>
                                                    <div>{t("username")}: </div>
                                                    <div>
                                                        <b>{ls?.user?.username}</b>
                                                    </div>
                                                </div>
                                                <div className="modalformgroup d-flex" style={{ padding: "9px" }}>
                                                    <div>{t("game")}: </div>
                                                    <div>
                                                        <b>{ls?.sanh}</b>
                                                    </div>
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("bet")}: </div>
                                                    <TextField name="state" defaultValue={ls?.state} sx={{ width: "100%" }} type="text" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>Số điểm cược: </div>
                                                    <TextField name="money" defaultValue={ls?.money} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>Số điểm thắng: </div>
                                                    <TextField name="moneythang" defaultValue={ls?.moneythang} sx={{ width: "100%" }} type="number" />
                                                </div>
                                                <div style={{ padding: "9px" }} className="modalformgroup d-flex">
                                                    <div>{t("status")}: </div>
                                                    <div>
                                                        <select name="status_bet" value={ls?.status_bet} onChange={handleChangeStatus}>
                                                            <option value="Win" selected={ls?.status_bet === "Win"} style={{ color: "#14B8A6" }}>
                                                                {t("win")}
                                                            </option>
                                                            <option value="Lose" selected={ls?.status_bet === "Lose"} style={{ color: "#D14343" }}>
                                                                {t("lose")}
                                                            </option>
                                                            <option value="Pending" selected={ls?.status_bet === "Pending"} style={{ color: "#FFB020" }}>
                                                                {t("pending")}
                                                            </option>
                                                            <option value="Cancelled" selected={ls?.status_bet === "Cancelled"} style={{ color: "#eee" }}>
                                                                {t("canceled")}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="item_btn_form">
                                                <div className="modalformcontrols">
                                                    <Button type="submit">{t("submit")}</Button>
                                                </div>
                                                <div className="modalformcontrols">
                                                    <Button onClick={() => setShow(false)}>{t("close")}</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}

                    {/* MODAL XEM CHI TIẾT XỔ SỐ */}
                    {isOpen && total ? (
                        <div className="popup-backdrop" style={{ maxWidth: "100%", zIndex: 9999 }}>
                            <div className="popup-main" style={{ maxWidth: "500px", margin: "0 auto" }}>
                                <div className="popup-header" style={{ fontSize: "18px" }}>
                                    {t("session")} {total?.id_bet}
                                </div>
                                <div className="popup-content" style={{ padding: "0" }}>
                                    <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: "10%" }}>ĐB</th>
                                                <td>
                                                    <span id="mb_prize_0" className="special-prize div-horizontal">
                                                        {total?.dacbiet}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>1</th>
                                                <td>
                                                    <span id="mb_prize_1" className="prize1 div-horizontal">
                                                        {total?.nhat}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>2</th>
                                                <td>
                                                    <span id="mb_prize_2" className="prize2 div-horizontal">
                                                        {total?.hai ? total.hai.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_3" className="prize2 div-horizontal">
                                                        {total?.hai ? total.hai.split(" ")[1] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>3</th>
                                                <td>
                                                    <span id="mb_prize_4" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_5" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[1] : ""}
                                                    </span>
                                                    <span id="mb_prize_6" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[2] : ""}
                                                    </span>
                                                    <span id="mb_prize_7" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[3] : ""}
                                                    </span>
                                                    <span id="mb_prize_8" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[4] : ""}
                                                    </span>
                                                    <span id="mb_prize_9" className="prize3 div-horizontal">
                                                        {total?.ba ? total.ba.split(" ")[5] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>4</th>
                                                <td>
                                                    <span id="mb_prize_10" className="prize4 div-horizontal">
                                                        {total?.tu ? total.tu.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_11" className="prize4 div-horizontal">
                                                        {total?.tu ? total.tu.split(" ")[1] : ""}
                                                    </span>
                                                    <span id="mb_prize_12" className="prize4 div-horizontal">
                                                        {total?.tu ? total.tu.split(" ")[2] : ""}
                                                    </span>
                                                    <span id="mb_prize_13" className="prize4 div-horizontal">
                                                        {total?.tu ? total.tu.split(" ")[3] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>5</th>
                                                <td>
                                                    <span id="mb_prize_14" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_15" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[1] : ""}
                                                    </span>
                                                    <span id="mb_prize_16" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[2] : ""}
                                                    </span>
                                                    <span id="mb_prize_17" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[3] : ""}
                                                    </span>
                                                    <span id="mb_prize_18" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[4] : ""}
                                                    </span>
                                                    <span id="mb_prize_19" className="prize5 div-horizontal">
                                                        {total?.nam ? total.nam.split(" ")[5] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>6</th>
                                                <td>
                                                    <span id="mb_prize_20" className="prize6 div-horizontal">
                                                        {total?.sau ? total.sau.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_21" className="prize6 div-horizontal">
                                                        {total?.sau ? total.sau.split(" ")[1] : ""}
                                                    </span>
                                                    <span id="mb_prize_22" className="prize6 div-horizontal">
                                                        {total?.sau ? total.sau.split(" ")[2] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>7</th>
                                                <td>
                                                    <span id="mb_prize_23" className="prize7 div-horizontal">
                                                        {total?.bay ? total.bay.split(" ")[0] : ""}
                                                    </span>
                                                    <span id="mb_prize_24" className="prize7 div-horizontal">
                                                        {total?.bay ? total.bay.split(" ")[1] : ""}
                                                    </span>
                                                    <span id="mb_prize_25" className="prize7 div-horizontal">
                                                        {total?.bay ? total.bay.split(" ")[2] : ""}
                                                    </span>
                                                    <span id="mb_prize_26" className="prize7 div-horizontal">
                                                        {total?.bay ? total.bay.split(" ")[3] : ""}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <button
                                    onClick={closePopup}
                                    className="popup-close"
                                    style={{
                                        background: "#00b977",
                                        boxShadow: "none",
                                        textShadow: "none",
                                        fontSize: "18px"
                                    }}>
                                    {t("close")}
                                </button>
                            </div>
                        </div>
                    ) : null}

                    {/* AX68WIN HƯỚNG DẪN CHI TIẾT MODAL */}
                    {isGuideOpen && (
                        <div className="ax-modal-overlay" onClick={() => setIsGuideOpen(false)}>
                            <div className="ax-modal-card" onClick={(e) => e.stopPropagation()}>
                                <div className="ax-modal-header">
                                    <h3>Hướng dẫn chi tiết</h3>
                                    <span className="close-icon" onClick={() => setIsGuideOpen(false)}>✕</span>
                                </div>
                                <div className="ax-modal-body">
                                    <h4>Khoảng thời gian</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với thời gian đã chọn.</li>
                                    </ul>

                                    <h4>Loại game</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Loại game' đã chọn.</li>
                                        <li>Mặc định là 'Toàn bộ'.</li>
                                    </ul>

                                    <h4>Sảnh và Thể loại</h4>
                                    <ul>
                                        <li>Chỉ có thể sử dụng khi 'Loại game' là: Game API.</li>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Sảnh' và 'Thể loại' đã chọn.</li>
                                        <li>Mặc định là 'Toàn bộ'.</li>
                                    </ul>

                                    <h4>Tên người chơi</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Tên người chơi' đã nhập vào ô văn bản.</li>
                                    </ul>

                                    <h4>Phiên</h4>
                                    <ul>
                                        <li>Được sử dụng để tìm kiếm các kết quả tương ứng với 'Phiên' đã nhập vào ô văn bản.</li>
                                    </ul>
                                </div>
                                <div className="ax-modal-footer">
                                    <button className="ax-btn-modal-close" onClick={() => setIsGuideOpen(false)}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </DashboardLayout>

                {/* 🔥 VẼ XÚC XẮC TÀI XỈU VÀ ĐỒNG XU XÓC ĐĨA BẰNG CSS THUẦN 🔥 */}
                <style>{`
                  `}</style>
            </ThemeProvider>
        </>
    );
}

export default HistoryBetAll;
